import { Reasoning, ReasoningContent, ReasoningTrigger } from '../elements/Reasoning';
import type { ChatMessagePart } from './utils';

type Props = {
  isReasoningStreaming: boolean;
  part: Extract<ChatMessagePart, { type: 'reasoning' }>;
};

const ReasoningMessagePart = ({ isReasoningStreaming, part }: Props) => (
  <Reasoning isStreaming={isReasoningStreaming} className='w-full'>
    <ReasoningTrigger />
    <ReasoningContent>{part.text}</ReasoningContent>
  </Reasoning>
);

export default ReasoningMessagePart;
